export interface ApiErrorDetail {
  readonly path?: string;
  readonly reason: string;
}

export interface ApiErrorBody {
  readonly error: {
    readonly code: string;
    readonly message: string;
    readonly requestId?: string;
    readonly details?: readonly ApiErrorDetail[];
  };
}

export interface CurrentUser {
  readonly id: string;
  readonly email: string;
  readonly displayName: string;
}

export interface MeResponse {
  readonly user: CurrentUser;
}

export interface CsrfTokenResponse {
  readonly token: string;
}

export function formatRevisionEtag(revision: number): string {
  if (!Number.isSafeInteger(revision) || revision < 1) {
    throw new RangeError('revision must be a positive safe integer');
  }
  return `"revision-${revision}"`;
}

export function parseRevisionEtag(value: string): number | null {
  const match = /^"revision-([1-9][0-9]*)"$/.exec(value.trim());
  if (match === null) return null;
  const revision = Number(match[1]);
  return Number.isSafeInteger(revision) ? revision : null;
}
